export enum BarcodeInterpretationMode {
  Default = -1,
  Order = 0,
  Article = 1
}

export default BarcodeInterpretationMode;
